document.addEventListener('DOMContentLoaded', initSpecificationTabs);
function initSpecificationTabs() {
    const sections = document.querySelectorAll('.product-tech-specification');

    sections.forEach(section => {
        const tabButtons = section.querySelectorAll('.specification-tab-controls-btn');
        const tabContents = section.querySelectorAll('.tech-specification-tab');

        tabButtons.forEach((button, index) => {
            button.addEventListener('click', () => {
                // Remove active states
                tabButtons.forEach(btn => btn.classList.remove('active'));
                tabContents.forEach(tab => tab.classList.remove('open'));

                // Set active states
                button.classList.add('active');
                tabContents[index].classList.add('open');
            });
        });
    });
}

